/* @flow */
import * as React from 'react';
import { type ThemeType } from 'react-css-themr';
import classnames from 'classnames';

type GridInjectedProps = {
    className: string,
    style: Object,
    dragging: boolean,
    onMouseUp: () => void,
    onMouseDown: () => void,
    onTouchStart: () => void,
    onTouchEnd: () => void,
    children: React.Node
};

type OwnProps = {
    render: ({ style: Object }) => React.Node,
    theme: ThemeType
};

type Props = {
    ...OwnProps,
    ...GridInjectedProps
};

class ReportGridItem extends React.PureComponent<Props> {
    render() {
        const { props } = this;
        return (
            <div
                className={classnames(
                    props.className,
                    props.theme.metricCardWrap
                )}
                data-dragging={props.dragging}
                style={props.style}
                onMouseUp={props.onMouseUp}
                onMouseDown={props.onMouseDown}
                onTouchEnd={props.onTouchEnd}
                onTouchStart={props.onTouchStart}
            >
                {props.render({ style: props.style })}
                {props.children}
            </div>
        );
    }
}

export default (ReportGridItem: React.AbstractComponent<OwnProps>);
